import React from 'react'
import { Link } from 'gatsby'
import { articleBody, tagNames } from '../styles/single.module.scss'

export default function ArticleTag({ tags, slug }) {
  return (
    <div className={articleBody}>
      {tags.map((tag) => (
        <p className={tagNames} key={tag.slug}>
          <Link to={`/${slug}/${tag.slug}`}>{`#${tag.title}`}</Link>
        </p>
      ))}
    </div>
  )
}
